import { render, staticRenderFns } from "./GenericUploadNew.vue?vue&type=template&id=83eb1126&"
import script from "./GenericUploadNew.vue?vue&type=script&lang=js&"
export * from "./GenericUploadNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports